module.exports = __webpack_public_path__ + "e378fab0377115ef677fd3d5d3e55249.svg";